import axios from 'axios';
import { toast } from 'react-toastify';

const API_BASE = process.env.REACT_APP_API_URL || '/api';
export const UPLOADS_BASE = API_BASE.replace(/\/api$/, '');

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

// Request interceptor - zawsze dodaj token z localStorage
api.interceptors.request.use(config => {
  const token = localStorage.getItem('carfleet_token');
  if (token && !config.headers['Authorization']) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  return config;
});

// Response interceptor
api.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    const msg = err.response?.data?.error || err.message;

    if (status === 401) {
      localStorage.removeItem('carfleet_token');
      if (window.location.pathname !== '/login') window.location.href = '/login';
    } else if (status === 403) {
      toast.error('Brak uprawnień do tej operacji');
    } else if (status >= 500) {
      const errMsg = err.response?.data?.error;
      toast.error(errMsg || 'Błąd serwera. Spróbuj ponownie później.');
    }

    return Promise.reject(err);
  }
);

export default api;
